module.exports = __webpack_public_path__ + "static/media/nav-logout.5e8edd2a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Header/nav-logout.svg
 ** module id = 1314
 ** module chunks = 0
 **/